export const LINKS_LIST = 'list';
export const LINK = 'link';
